// Section / field schema that drives the accordion in CreateEventModal.
// Adding a new section here automatically registers a new step in the
// wizard — the component renders everything from this array.

export const SECTIONS = [
  {
    id: "image",
    title: "Event Image",
    fields: [{ id: "imageUrl", label: "Cover Image", type: "image", required: true }],
  },
  {
    id: "details",
    title: "Event Details",
    fields: [
      { id: "name", label: "Event Name", type: "text", placeholder: "Beach Day, Coffee Meetup, etc.", required: true },
      { id: "description", label: "Description", type: "textarea", placeholder: "Describe your event…", required: true },
      { id: "guestsToBring", label: "What to Bring", type: "textarea", placeholder: "Water, towel, sunscreen, etc.", required: false },
    ],
  },
  {
    id: "location",
    title: "Location",
    fields: [
      { id: "_addressSearch", label: "Search Address", type: "address-search", placeholder: "Search for a location…", required: true },
    ],
  },
  {
    id: "schedule",
    title: "Date & Time",
    fields: [
      { id: "startDate", label: "Start Date", type: "date", required: true },
      { id: "startTime", label: "Start Time", type: "time", required: true },
      { id: "endDate", label: "End Date", type: "date", required: true },
      { id: "endTime", label: "End Time", type: "time", required: false },
    ],
  },
  {
    id: "pricing",
    title: "Pricing & Capacity",
    fields: [
      { id: "cost", label: "Cost (CAD)", type: "number", placeholder: "0", required: false },
      { id: "maxMembers", label: "Max Attendees", type: "number", placeholder: "10", required: true },
    ],
  },
  {
    id: "interests",
    title: "Interests",
    fields: [{ id: "interests", label: "Event Categories", type: "interests", required: true }],
  },
];
